import type { FC } from 'react'
import { useId } from 'react'

import { DatePicker as AntDatePicker, Skeleton } from 'antd'
import classNames from 'classnames'

import { Label } from 'common/components/Label/Label'
import { Show } from 'common/components/Show/Show'
import { INPUT_PLACEHOLDER } from 'common/constants/inputConstants'

import styles from './datepicker.module.scss'
import { type DatePickerProps } from 'antd/lib'

type Props = DatePickerProps & {
  label?: string
  isLoading?: boolean
  required?: boolean
  placeholder?: string
  parentClassName?: string
  inputContainerClassName?: string
  isActive?: boolean
  error?: string
}

export const DatePicker: FC<Props> = ({
  label,
  isLoading,
  required,
  placeholder,
  parentClassName,
  inputContainerClassName,
  isActive,
  error,
  ...rest
}) => {
  const id = useId()

  return (
    <div className={classNames(styles.parent, parentClassName)}>
      <Label id={id} required={required} label={label} />
      <div className={classNames(styles.container, inputContainerClassName)} data-active={isActive}>
        <Show
          when={!isLoading}
          fallback={<Skeleton.Input className={styles.containerSkeleton} active />}>
          <AntDatePicker
            id={id}
            placeholder={placeholder || INPUT_PLACEHOLDER.TYPE_HERE}
            {...rest}
          />
        </Show>
      </div>
      <Show when={!!error}>
        <p className='errorMessage'>{error}</p>
      </Show>
    </div>
  )
}
